import { render, staticRenderFns } from "./RationsTableMobile.vue?vue&type=template&id=83488be4&scoped=true&lang=pug&"
import script from "./RationsTableMobile.vue?vue&type=script&lang=js&"
export * from "./RationsTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./RationsTableMobile.vue?vue&type=style&index=0&id=83488be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83488be4",
  null
  
)

export default component.exports